var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center main-links"},[_c('div',{staticClass:"header-container d-flex flex-column py-3 flex-shrink-0",class:_vm.notMobile ? 'px-3' : 'px-1'},[(!_vm.showSubMenu)?_c('div',{staticClass:"d-flex align-items-center justify-content-center mb-0",on:{"click":_vm.emitSubMenuShow}},[_c('img',{class:[
          {'opacity-80 -translate-scale-1': !_vm.isLangRtl},
          'cursor-pointer'
        ],attrs:{"src":require('@/assets/images/icons/bread_crumb_double.svg'),"alt":"Sales","width":"24","height":"24"}})]):_vm._e(),_c('div',{staticClass:"d-flex align-items-center justify-content-center mt-4 mb-2 text-white text-decoration-none"},[(_vm.$store.getters['enums/operator'] === 'eJ')?_c('img',{staticClass:"nav-sss-logo",attrs:{"src":require("@/assets/logo/small-logo.svg"),"alt":"logo"}}):_vm._e()]),_c('div',{staticClass:"mb-5",staticStyle:{"overflow-y":"auto"}},[_c('ul',{staticClass:"nav nav-pills flex-column mb-auto"},[(!_vm.$store.getters['enums/is_not_permitted']('dashboardTab'))?_c('li',{staticClass:"nav-item my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('dashboard'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('dashboard'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'dashboard',
              },
            ],attrs:{"id":"sidebar-link-dashboard","to":"/dashboard/map","aria-current":"page"}},[_c('img',{attrs:{"src":_vm.$route.name == 'dashboard'
                  ? require('@/assets/images/icons/dashboard-dark.svg')
                  : require('@/assets/images/icons/dashboard.svg'),"alt":"dashboard","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted']('clientTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('listBlanketOrder') ||
            !_vm.$store.getters['enums/is_not_permitted']('operationsReservationTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('viewClientRatings')
          )?_c('li',{staticClass:"nav-item my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('sales'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('sales'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'clients' ||
                  _vm.$route.name == 'operations' ||
                  _vm.$route.name == 'blanket-orders' ||
                  _vm.$route.name == 'client-feedbacks' ,
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted'](
                'operationsReservationTab'
              )
                ? 'sidebar-link-sales'
                : !_vm.$store.getters['enums/is_not_permitted']('clientTab')
                ? 'sidebar-link-clients'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'listBlanketOrder'
                  )
                ? 'sidebar-link-blanket-orders'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewClientRatings'
                  )
                ? 'sidebar-link-client-feedbacks' : '',"to":!_vm.$store.getters['enums/is_not_permitted'](
                'operationsReservationTab'
              )
                ? '/operations/list'
                : !_vm.$store.getters['enums/is_not_permitted']('clientTab')
                ? '/clients'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'listBlanketOrder'
                  )
                ? '/blanket-orders'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewClientRatings'
                  )
                ? '/client-feedbacks' : '',"aria-current":"page"}},[_c('img',{attrs:{"src":_vm.$route.name == 'operations'
                  ? require('@/assets/images/icons/sales-icon-dark.svg')
                  : require('@/assets/images/icons/sales-icon-light.svg'),"alt":"Sales","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted'](
              'operationsContractedJourneyTab'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'operationsCheckAvailabilityTab'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted']('reportedIssues') ||
            !_vm.$store.getters['enums/is_not_permitted']('transactionLogTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('viewDriverAllowance')
          )?_c('li',{staticClass:"nav-item my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('operations'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('operations'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'departure-arrival' ||
                  _vm.$route.name == 'vehicle-operations' ||
                  _vm.$route.name == 'manage-trips' ||
                  _vm.$route.name == 'trip-import-logs' ||
                  _vm.$route.name == 'transaction-log' ||
                  _vm.$route.name == 'driver-allowance' ||
                  _vm.$route.name == 'vehicle-signal-validation' ||
                  _vm.$route.name == 'check-availability' ||
                  _vm.$route.name == 'long-terms' ||
                  _vm.$route.name == 'reported-issues',
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted'](
                'operationsContractedJourneyTab'
              )
                ? 'sidebar-link-manage-trips'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'operationsCheckAvailabilityTab'
                  )
                ? 'sidebar-link-check-availability'
                : !_vm.$store.getters['enums/is_not_permitted']('reportedIssues')
                ? 'sidebar-link-reported-issues'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'transactionLogTab'
                  )
                ? 'sidebar-link-transaction-log'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance'
                  )
                ? 'sidebar-link-driver-allowance'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance'
                  )
                ? 'sidebar-link-vehicle-signal-validation'
                : '',"to":!_vm.$store.getters['enums/is_not_permitted'](
                'operationsContractedJourneyTab'
              )
                ? '/manage-trips'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'operationsCheckAvailabilityTab'
                  )
                ? '/check-availability'
                : !_vm.$store.getters['enums/is_not_permitted']('reportedIssues')
                ? '/reported-issues'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'transactionLogTab'
                  )
                ? '/transaction-log'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance'
                  )
                ? '/driver-allowance'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance'
                  )
                ? '/vehicle-signal-validation'
                : '',"aria-current":"page"}},[_c('img',{attrs:{"src":_vm.$route.name == 'departure-arrival' ||
                _vm.$route.name == 'vehicle-operations' ||
                _vm.$route.name == 'manage-trips' ||
                _vm.$route.name == 'trip-import-logs' ||
                _vm.$route.name == 'transaction-log' ||
                _vm.$route.name == 'driver-allowance' ||
                _vm.$route.name == 'vehicle-signal-validation' ||
                _vm.$route.name == 'check-availability' ||
                _vm.$route.name == 'long-terms' ||
                _vm.$route.name == 'reported-issues'
                  ? require('@/assets/images/icons/setting-icon-dark.svg')
                  : require('@/assets/images/icons/setting-icon-light.svg'),"alt":"Operations","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted']('driverTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('vehicleTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('resourceLogView')
          )?_c('li',{staticClass:"nav-item my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('resources'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('resources'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'drivers' || _vm.$route.name == 'vehicles' ||
                  _vm.$route.name == 'resource-logs',
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted']('driverTab')
                ? 'sidebar-link-drivers'
                : !_vm.$store.getters['enums/is_not_permitted']('vehicleTab')
                ? 'sidebar-link-vehicles'
                : !_vm.$store.getters['enums/is_not_permitted']('resourceLogView')
                ? 'sidebar-link-resource-logs'
                : '',"to":!_vm.$store.getters['enums/is_not_permitted']('driverTab')
                ? '/drivers'
                : !_vm.$store.getters['enums/is_not_permitted']('vehicleTab')
                ? '/vehicles'
                : !_vm.$store.getters['enums/is_not_permitted']('resourceLogView')
                ? '/resource-logs'
                : '',"aria-current":"page"}},[_c('img',{attrs:{"src":_vm.$route.name == 'drivers' || _vm.$route.name == 'vehicles' || _vm.$route.name == 'resource-logs'
                  ? require('@/assets/images/icons/client-dark.svg')
                  : require('@/assets/images/icons/client.svg'),"alt":"Operations","width":"24","height":"24"}})])],1):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('contractTab'))?_c('li',{staticClass:"nav-item my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('contracts'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('contracts'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'contracts'
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted']('contractTab') ? 'sidebar-link-contracts' : '',"to":!_vm.$store.getters['enums/is_not_permitted']('contractTab') ? '/contracts' : '',"aria-current":"page"}},[_c('img',{attrs:{"src":require('@/assets/images/icons/contract-icon.svg'),"alt":"contracts","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted'](
              'viewTemporaryRequest'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'viewTemporaryResourcesRequest'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'viewReservationRequest'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted']('replaceRequestTab') ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'operationsApprovalRequestTab'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted']('timeOffRequest') ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'viewReservationRequest'
            ) ||
            !_vm.$store.getters['enums/is_not_permitted']('viewDriverAllowance') ||
            (!_vm.$store.getters['enums/is_not_permitted'](
              'manageAllTasks'
            ) || !_vm.$store.getters['enums/is_not_permitted']('viewMyTasks'))
          )?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('requests'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('requests'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'resource-requests' ||
                  _vm.$route.name == 'my-requests' ||
                  _vm.$route.name == 'replace-requests-list' ||
                  _vm.$route.name == 'approval-requests' ||
                  _vm.$route.name == 'time-off-requests' ||
                  _vm.$route.name == 'reservations-requests'||
                  _vm.$route.name == 'allowance-requests' || 
                  _vm.$route.name == 'workflow-requests',
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted'](
                'viewTemporaryRequest'
              )
                ? 'sidebar-link-resource-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewTemporaryResourcesRequest'
                  ) ||
                  !_vm.$store.getters['enums/is_not_permitted'](
                    'viewReservationRequest'
                  )
                ? 'sidebar-link-my-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'replaceRequestTab'
                  )
                ? 'sidebar-link-replace-requests-list'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'operationsApprovalRequestTab'
                  )
                ? 'sidebar-link-approval-requests'
                : !_vm.$store.getters['enums/is_not_permitted']('timeOffRequest')
                ? 'sidebar-link-time-off-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewReservationRequest'
                  )
                ? 'sidebar-link-reservations-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance' 
                  )
                ? 'sidebar-link-allowance-requests'
                : (!_vm.$store.getters['enums/is_not_permitted'](
                    'manageAllTasks' 
                  ) || !_vm.$store.getters['enums/is_not_permitted'](
                    'viewMyTasks' 
                  ))
                ? 'sidebar-link-workflow-requests' :'',"to":!_vm.$store.getters['enums/is_not_permitted'](
                'viewTemporaryRequest'
              )
                ? '/resource-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewTemporaryResourcesRequest'
                  ) ||
                  !_vm.$store.getters['enums/is_not_permitted'](
                    'viewReservationRequest'
                  )
                ? '/my-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'replaceRequestTab'
                  )
                ? '/replace-requests-list'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'operationsApprovalRequestTab'
                  )
                ? '/approval-requests'
                : !_vm.$store.getters['enums/is_not_permitted']('timeOffRequest')
                ? '/time-off-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewReservationRequest'
                  )
                ? '/reservations-requests'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewDriverAllowance' 
                  )
                ? '/allowance-requests'
                : (!_vm.$store.getters['enums/is_not_permitted'](
                    'manageAllTasks' 
                  ) || !_vm.$store.getters['enums/is_not_permitted'](
                    'viewMyTasks' 
                  ))
                ? '/workflow-requests' : ''}},[_c('img',{attrs:{"src":_vm.$route.name == 'resource-requests' ||
                _vm.$route.name == 'my-requests' ||
                _vm.$route.name == 'replace-requests-list' ||
                _vm.$route.name == 'approval-requests' ||
                _vm.$route.name == 'time-off-requests' ||
                _vm.$route.name == 'reservations-requests' ||
                _vm.$route.name == 'allowance-requests' ||
                _vm.$route.name == 'workflow-requests'
                  ? require('@/assets/images/icons/requests-icon-dark.svg')
                  : require('@/assets/images/icons/requests-icon.svg'),"alt":"requests-icon","width":"24","height":"24"}})])],1):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('supportChatTab'))?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('messaging-center'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('messaging-center'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'messaging-center',
              },
            ],attrs:{"id":"sidebar-link-messaging-center","to":"/messaging-center"}},[_c('img',{attrs:{"src":_vm.$route.name == 'messaging-center'
                  ? require('@/assets/images/icons/messaging-center-icon.svg')
                  : require('@/assets/images/icons/messaging-center-icon-light.svg'),"alt":"messaging-center","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted'](
              'systemManagementTab'
            ) &&
            (!_vm.$store.getters['enums/is_not_permitted']('systemCategoryTab') ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemRegionManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemDriverManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemSlotsManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemSalesOrderManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemVehiclesManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemCompaniesManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemUserAndRolesManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemProductsManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemTraningTypeManagementTab'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'systemTgaManagementTab'
              ))
          )?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('system-management'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('system-management'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'system-management',
              },
            ],attrs:{"id":"sidebar-link-system-management","to":"/system-management"}},[_c('img',{attrs:{"src":_vm.$route.name == 'SystemManagementView'
                  ? require('@/assets/images/icons/system-management-dark.svg')
                  : require('@/assets/images/icons/management-system.svg'),"alt":"System Management","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted']('receiptVoucherTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('financeAccountsTab') ||
            !_vm.$store.getters['enums/is_not_permitted'](
              'financeProformaInvoiceTab'
            ) ||
            _vm.$store.getters['enums/is_not_permitted']('financeJVTab') ||
            !_vm.$store.getters['enums/is_not_permitted']('viewTransaction') ||
            !_vm.$store.getters['enums/is_not_permitted']('viewPaymentVoucher') ||
            !_vm.$store.getters['enums/is_not_permitted']('taxTypeTab') ||
            // !$store.getters['enums/is_not_permitted'](
            //   'financeClientStatmentTab'
            // ) ||
            !_vm.$store.getters['enums/is_not_permitted']('viewFinancialClaim') ||
            !_vm.$store.getters['enums/is_not_permitted']('masterAccountsTab')
          )?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('finances'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('finances'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'finances' ||
                  _vm.$route.name == 'account-listing' ||
                  _vm.$route.name == 'proforma-invoice-listing' ||
                  _vm.$route.name == 'jv-listing' ||
                  _vm.$route.name == 'tax-types' ||
                  _vm.$route.name == 'post-transactions' ||
                  _vm.$route.name == 'payment-voucher' ||
                  _vm.$route.name == 'statement' ||
                  _vm.$route.name == 'financial-claim' ||
                  _vm.$route.name == 'master-accounts',
              },
            ],attrs:{"id":!_vm.$store.getters['enums/is_not_permitted']('receiptVoucherTab')
                ? 'sidebar-link-finances'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'financeAccountsTab'
                  )
                ? 'sidebar-link-account-listing'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'financeProformaInvoiceTab'
                  )
                ? 'sidebar-link-proforma-invoice-listing'
                : _vm.$store.getters['enums/is_not_permitted']('financeJVTab')
                ? 'sidebar-link-jv-listing'
                : !_vm.$store.getters['enums/is_not_permitted']('viewTransaction')
                ? 'sidebar-link-post-transactions-listing'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewPaymentVoucher'
                  )
                ? 'sidebar-link-payment-voucher-listing'
                : !_vm.$store.getters['enums/is_not_permitted']('taxTypeTab')
                ? 'sidebar-link-tax-types-listing'
                // : !$store.getters['enums/is_not_permitted'](
                //     'financeClientStatmentTab'
                //   )
                // ? 'sidebar-link-finance-statement'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'masterAccountsTab'
                  )
                ? 'sidebar-link-master-accounts'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewFinancialClaim'
                  )
                ? 'sidebar-link-financial-claim-listing' : '',"to":!_vm.$store.getters['enums/is_not_permitted']('receiptVoucherTab')
                ? '/finances'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'financeAccountsTab'
                  )
                ? '/account-listing'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'financeProformaInvoiceTab'
                  )
                ? '/proforma-invoice-listing'
                : _vm.$store.getters['enums/is_not_permitted']('financeJVTab')
                ? '/jv-listing'
                : !_vm.$store.getters['enums/is_not_permitted']('viewTransaction')
                ? '/post-transactions'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewPaymentVoucher'
                  )
                ? '/payment-voucher'
                : !_vm.$store.getters['enums/is_not_permitted']('taxTypeTab')
                ? '/tax-types'
                // : !$store.getters['enums/is_not_permitted'](
                //     'financeClientStatmentTab'
                //   )
                // ? '/statement'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'masterAccountsTab'
                  )
                ? '/master-accounts'
                : !_vm.$store.getters['enums/is_not_permitted'](
                    'viewFinancialClaim'
                  )
                ? '/financial-claim' : ''}},[_c('img',{attrs:{"src":_vm.$route.name == 'finances' ||
                _vm.$route.name == 'account-listing' ||
                _vm.$route.name == 'proforma-invoice-listing' ||
                _vm.$route.name == 'jv-listing' ||
                _vm.$route.name == 'tax-types' ||
                _vm.$route.name == 'post-transactions' ||
                _vm.$route.name == 'payment-voucher' ||
                _vm.$route.name == 'statement' ||
                _vm.$route.name == 'financial-claim' ||
                _vm.$route.name == 'master-accounts'
                  ? require('@/assets/images/icons/finance-icon-dark.svg')
                  : require('@/assets/images/icons/finance-icon.svg'),"alt":"finance-icon","width":"24","height":"24"}})])],1):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('supplierTab'))?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('partners'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('partners'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'suppliers',
              },
            ],attrs:{"id":"sidebar-link-suppliers","to":"/suppliers"}},[_c('img',{attrs:{"src":_vm.$route.name == 'suppliers'
                  ? require('@/assets/images/icons/ap-ar-dark.svg')
                  : require('@/assets/images/icons/ap-ar.svg'),"alt":"ap-ar-icon","width":"24","height":"24"}})])],1):_vm._e(),(
            !_vm.$store.getters['enums/is_not_permitted']('companyProfileTab')
          )?_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('company-profile'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('company-profile'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'CompanyProfile',
              },
            ],attrs:{"id":"sidebar-link-company-profile","to":"/company-profile"}},[_c('img',{attrs:{"src":_vm.$route.name == 'CompanyProfile'
                  ? require('@/assets/images/icons/company-profile-dark.svg')
                  : require('@/assets/images/icons/company-profile.svg'),"alt":"System Management","width":"24","height":"24"}})])],1):_vm._e(),_c('li',{staticClass:"my-2"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
              title: _vm.$t('my-profile'),
              placement: _vm.isLangRtl ? 'left' : 'right',
            }),expression:"{\n              title: $t('my-profile'),\n              placement: isLangRtl ? 'left' : 'right',\n            }",modifiers:{"hover":true}}],class:[
              'nav-link ',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'change-password',
              },
            ],attrs:{"id":"sidebar-link-my-profile","to":"/change-password"}},[_c('img',{attrs:{"src":_vm.$route.name == 'change-password'
                  ? require('@/assets/images/icons/my-profile-dark.svg')
                  : require('@/assets/images/icons/my-profile.svg'),"alt":"change-password","width":"24","height":"24"}})])],1)])]),_c('div',{staticStyle:{"position":"absolute","bottom":"1rem"}},[_c('ul',{staticClass:"nav nav-pills flex-column mb-auto"},[_c('li',{staticClass:"mt-3"},[_c('div',{staticClass:"nav-link cursor-pointer",attrs:{"id":"sidebar-link-logout"},on:{"click":_vm.logout}},[_c('img',{attrs:{"src":require('@/assets/images/icons/LogOut.svg'),"alt":"LogOut","width":"24","height":"24"}})])])])])]),(
      (
        _vm.isCollapsed1 ||
        _vm.isCollapsed2 ||
        _vm.isCollapsed3 ||
        _vm.isCollapsed4 ||
        _vm.isCollapsed5 ||
        _vm.isCollapsed6 ||
        _vm.isCollapsed7 ||
        _vm.isCollapsed8
      ) && _vm.showSubMenu
    )?_c('div',{staticClass:"header-container d-flex flex-column py-3 flex-shrink-0 sub-links"},[_c('div',{staticClass:"ms-auto position-absolute toggle-sub-menu",on:{"click":_vm.toggleSubMenu}},[_c('img',{class:{
          'cursor-pointer me-3 opacity-80': true,
          '-translate-scale-1': _vm.isLangRtl,
        },attrs:{"src":require('@/assets/images/icons/bread_crumb_double.svg'),"alt":"Sales","width":"24","height":"24"}})]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed1)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed1 },attrs:{"id":"sidebar-link-collapse1-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("operations"))+" ")])]),(_vm.$store.getters['enums/user_info'].branch)?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'departure-arrival',
              },
            ],attrs:{"id":"sidebar-link-departure-arrival","to":"/departure-arrival"}},[_vm._v(" "+_vm._s(_vm.$t("departure-arrival"))+" ")]):_vm._e(),(
              false &&
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsVehicleTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'vehicle-operations',
              },
            ],attrs:{"id":"sidebar-link-vehicle-operations","to":"/vehicle-operations"}},[_vm._v(" "+_vm._s(_vm.$t("vehicles"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsContractedJourneyTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'manage-trips',
              },
            ],attrs:{"id":"sidebar-link-manage-trips","to":"/manage-trips"}},[_vm._v(" "+_vm._s(_vm.$t("manage-trips"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsContractedJourneyTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'trip-import-logs',
              },
            ],attrs:{"id":"sidebar-link-trip-import-logs","to":"/trip-import-logs"}},[_vm._v(" "+_vm._s(_vm.$t("trip-import-logs"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsCheckAvailabilityTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'check-availability',
              },
            ],attrs:{"id":"sidebar-link-check-availability","to":"/check-availability"}},[_vm._v(" "+_vm._s(_vm.$t("check-availability"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('reportedIssues'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'reported-issues',
              },
            ],attrs:{"id":"sidebar-link-reported-issues","to":"/reported-issues"}},[_vm._v(" "+_vm._s(_vm.$t("reported-issues"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('transactionLogTab')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'transaction-log',
              },
            ],attrs:{"id":"sidebar-link-transaction-log","to":"/transaction-log"}},[_vm._v(" "+_vm._s(_vm.$t("transaction-log"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewDriverAllowance')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'driver-allowance',
              },
            ],attrs:{"id":"sidebar-link-driver-allowance","to":"/driver-allowance"}},[_vm._v(" "+_vm._s(_vm.$t("driver-allowance"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewDriverAllowance')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'vehicle-signal-validation',
              },
            ],attrs:{"id":"sidebar-link-vehicle-signal-validation","to":"/vehicle-signal-validation"}},[_vm._v(" "+_vm._s(_vm.$t("vehicle-trackable"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed2)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed2 },attrs:{"id":"sidebar-link-collapse2-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("finances"))+" ")])]),(
              !_vm.$store.getters['enums/is_not_permitted']('receiptVoucherTab')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'finances',
              },
            ],attrs:{"id":"sidebar-link-finances","to":"/finances"}},[_vm._v(" "+_vm._s(_vm.$t("receipt-vouchers"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('financeAccountsTab')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'account-listing',
              },
            ],attrs:{"id":"sidebar-link-account-listing","to":"/account-listing"}},[_vm._v(" "+_vm._s(_vm.$t("accounts"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'financeProformaInvoiceTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'proforma-invoice-listing',
              },
            ],attrs:{"id":"sidebar-link-proforma-invoice-listing","to":"/proforma-invoice-listing"}},[_vm._v(" "+_vm._s(_vm.$t("proforma-invoices"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('financeJVTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'jv-listing',
              },
            ],attrs:{"id":"sidebar-link-jv-listing","to":"/jv-listing"}},[_vm._v(" "+_vm._s(_vm.$t("journal-vouchers"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewTransaction')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'post-transactions',
              },
            ],attrs:{"id":"sidebar-link-post-transactions-listing","to":"/post-transactions"}},[_vm._v(" "+_vm._s(_vm.$t("post-transactions"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewPaymentVoucher')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'payment-voucher',
              },
            ],attrs:{"id":"sidebar-link-payment-voucher-listing","to":"/payment-voucher"}},[_vm._v(" "+_vm._s(_vm.$t("payment-voucher"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewFinancialClaim')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'financial-claim',
              },
            ],attrs:{"id":"sidebar-link-financial-claim-listing","to":"/financial-claim"}},[_vm._v(" "+_vm._s(_vm.$t("financial-claim"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('taxTypeTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'tax-types',
              },
            ],attrs:{"id":"sidebar-link-tax-types-listing","to":"/tax-types"}},[_vm._v(" "+_vm._s(_vm.$t("tax-types"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('masterAccountsTab')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'master-accounts',
              },
            ],attrs:{"id":"sidebar-link-master-accounts","to":"/master-accounts"}},[_vm._v(" "+_vm._s(_vm.$t("master-accounts"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed3)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed3 },attrs:{"id":"sidebar-link-collapse2-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("resources"))+" ")])]),(!_vm.$store.getters['enums/is_not_permitted']('driverTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'drivers',
              },
            ],attrs:{"id":"sidebar-link-drivers","to":"/drivers"}},[_vm._v(" "+_vm._s(_vm.$t("drivers"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('vehicleTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'vehicles',
              },
            ],attrs:{"id":"sidebar-link-vehicles","to":"/vehicles"}},[_vm._v(" "+_vm._s(_vm.$t("vehicles"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('resourceLogView'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'resource-logs',
              },
            ],attrs:{"id":"sidebar-link-resource-logs","to":"/resource-logs"}},[_vm._v(" "+_vm._s(_vm.$t("resource-logs"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed4)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed4 },attrs:{"id":"sidebar-link-collapse2-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("partners"))+" ")])]),(!_vm.$store.getters['enums/is_not_permitted']('supplierTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'suppliers',
              },
            ],attrs:{"id":"sidebar-link-suppliers","to":"/suppliers"}},[_vm._v(" "+_vm._s(_vm.$t("suppliers"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed5)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed5 },attrs:{"id":"sidebar-link-collapse2-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("requests"))+" ")])]),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'viewTemporaryRequest'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'resource-requests',
              },
            ],attrs:{"id":"sidebar-link-resource-requests","to":"/resource-requests"}},[_vm._v(" "+_vm._s(_vm.$t("resource-requests"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'viewTemporaryResourcesRequest'
              ) ||
              !_vm.$store.getters['enums/is_not_permitted'](
                'viewReservationRequest'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'my-requests',
              },
            ],attrs:{"id":"sidebar-link-my-requests","to":"/my-requests"}},[_vm._v(" "+_vm._s(_vm.$t("my-requests"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('replaceRequestTab')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'replace-requests-list',
              },
            ],attrs:{"id":"sidebar-link-replace-requests-list","to":"/replace-requests-list"}},[_vm._v(" "+_vm._s(_vm.$t("replace-requests"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsApprovalRequestTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'approval-requests',
              },
            ],attrs:{"id":"sidebar-link-approval-requests","to":"/approval-requests"}},[_vm._v(" "+_vm._s(_vm.$t("approval-requests"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('timeOffRequest'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'time-off-requests',
              },
            ],attrs:{"id":"sidebar-link-time-off-requests","to":"/time-off-requests"}},[_vm._v(" "+_vm._s(_vm.$t("time-off-requests"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'viewReservationRequest'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'reservations-requests',
              },
            ],attrs:{"id":"sidebar-link-reservations-requests","to":"/reservations-requests"}},[_vm._v(" "+_vm._s(_vm.$t("reservations-requests"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'viewDriverAllowance'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'allowance-requests',
              },
            ],attrs:{"id":"sidebar-link-allowance-requests","to":"/allowance-requests"}},[_vm._v(" "+_vm._s(_vm.$t("allowance-requests"))+" ")]):_vm._e(),(
    !_vm.$store.getters['enums/is_not_permitted'](
                    'manageAllTasks' 
                  ) || !_vm.$store.getters['enums/is_not_permitted'](
                    'viewMyTasks' 
                  )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'workflow-requests',
              },
            ],attrs:{"id":"sidebar-link-workflow-requests","to":"/workflow-requests"}},[_vm._v(" "+_vm._s(_vm.$t("workflow-requests"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed6)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed6 },attrs:{"id":"sidebar-link-collapse2-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("sales"))+" ")])]),(
              !_vm.$store.getters['enums/is_not_permitted'](
                'operationsReservationTab'
              )
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'operations',
              },
            ],attrs:{"id":"sidebar-link-operations","to":"/operations/list"}},[_vm._v(" "+_vm._s(_vm.$t("reservations"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('clientTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'clients',
              },
            ],attrs:{"id":"sidebar-link-clients","to":"/clients"}},[_vm._v(" "+_vm._s(_vm.$t("clients"))+" ")]):_vm._e(),(!_vm.$store.getters['enums/is_not_permitted']('clientTab'))?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'main-client-accounts' ||
                  _vm.$route.name == 'main-client-account-details' ||
                  _vm.$route.name == 'main-client-account-sales-order-details' ||
                  _vm.$route.name == 'main-client-account-financial-transactions' ||
                  _vm.$route.name == 'add-main-client-account' ||
                  _vm.$route.name == 'edit-main-client-account',
              },
            ],attrs:{"id":"sidebar-link-main-client","to":"/main-client-accounts"}},[_vm._v(" "+_vm._s(_vm.$t("main-client"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('listBlanketOrder')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'blanket-orders',
              },
            ],attrs:{"id":"sidebar-link-blanket-orders","to":"/blanket-orders"}},[_vm._v(" "+_vm._s(_vm.$t("blanket-orders"))+" ")]):_vm._e(),(
              !_vm.$store.getters['enums/is_not_permitted']('viewClientRatings')
            )?_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'client-feedbacks',
              },
            ],attrs:{"id":"sidebar-link-client-feedbacks","to":"/client-feedbacks"}},[_vm._v(" "+_vm._s(_vm.$t("client-feedbacks"))+" ")]):_vm._e()],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed7)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed7 },attrs:{"id":"sidebar-link-collapse7-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("my-profile"))+" ")])]),_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'change-password',
              },
            ],attrs:{"id":"sidebar-link-change-password","to":"/change-password"}},[_vm._v(" "+_vm._s(_vm.$t("change-password"))+" ")])],1)]):_vm._e()]),_c('transition',{attrs:{"name":"collapse-transition"}},[(_vm.isCollapsed8)?_c('div',{staticClass:"sidebar-content mx-3 d-flex",class:{ collapsed: _vm.isCollapsed8 },attrs:{"id":"sidebar-link-collapse8-transition"}},[_c('div',[_c('div',{staticClass:"mt-4 mb-3"},[_c('strong',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t("contracts"))+" ")])]),_c('router-link',{class:[
              'nav-link sub-nav-link my-2',
              {
                'router-link-exact-active router-link-active':
                  _vm.$route.name == 'contracts',
              },
            ],attrs:{"id":"sidebar-link-contracts","to":"/contracts"}},[_vm._v(" "+_vm._s(_vm.$t("contracts"))+" ")])],1)]):_vm._e()])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }